import React from 'react';

import EnvPill, { envPillStyle, EnvPillSize } from '../../components/ui/EnvPill';

/**
 * EnvBadge — thin back-compat wrapper over the canonical {@link EnvPill}.
 * Existing callers (authoring-env card, editing-env map) keep the same API and
 * automatically get the modern tinted-pill look. New code should import EnvPill
 * directly from components/ui.
 *
 * envBadgeColor is retained for callers that need just the saturated dot colour
 * (now sourced from envPillStyle so it stays consistent with the pill).
 */
export const envBadgeColor = (name: string): string => envPillStyle(name).dot;

const EnvBadge: React.FC<{ env: string; showLabel?: boolean; size?: EnvPillSize }> = ({
  env,
  showLabel = true,
  size = 'sm',
}) => <EnvPill env={env} showLabel={showLabel} size={size} />;

export default EnvBadge;
